import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import phone from "phone";

@ValidatorConstraint({ name: 'ValidPhone', async: false })
export class PhoneValidatorConstraint implements ValidatorConstraintInterface {
    validate(phoneNumber: any, args: ValidationArguments) {
        const object: any = args.object;
        const [countryField = 'phone_country', phoneField = 'phone_number'] = args.constraints || [];
        const number = String(object[phoneField] || '').trim();
        if (!number) return true;
        return phone(String(object[countryField] || '') + number)['isValid'];
    }

    defaultMessage(args: ValidationArguments) {
        return 'validation.please_enter_a_valid_phone_number';
    }
}
